import React, { StrictMode } from "react";
import { ColorSchemeProvider } from "./src/context/ColorSchemeContext";
import { I18nProvider } from "./src/context/I18nContext";
import { KeycloakProvider } from "./src/context/KeycloakContext";
import { AppRouter } from "./src/navigation/AppRouter";

function App() {
  return (
    <StrictMode>
      <ColorSchemeProvider>
        <I18nProvider>
          <KeycloakProvider>
            <AppRouter />
          </KeycloakProvider>
        </I18nProvider>
      </ColorSchemeProvider>
    </StrictMode>
  );
}
export default App;
